<template>
    <div>
    </div>
</template>

<script>
    

    export default {
        name: "OpenMarketRedirectPage",

        data() {
            return {

            }
        },

        created() {
            let search = window.location.search
            this.doRedirect(search);
        },

        methods: {
            doRedirect(search) {
                this.$router.push("/open-market"+search)
            },
        },
    }
</script>

<style scoped>

</style>